<template>
  <div class="content">
    <div class="modal">
      <span
        class="close"
        @click="$emit('close-modal')"
      >
        <icon
          class="close-icon"
          icon="Close"
        />
      </span>
      <div class="scrollable">
        <figure>
          <img src="@/assets/img/ic_dadosimcompletos.png">
        </figure>
        <div class="text">
          <p class="title">
            <b>Bem-vindo a sua unidade de saúde on-line</b>
          </p>
          <p class="bottom-line">
            Recebemos seu cadastro com sucesso e estamos validando as informações junto à Unidade de Saúde.
          </p>
        </div>
        <div class="check-list">
          <div class="check-list--item info">
            <div
              v-if="!userGender"
              class="status pending"
            >
              <icon
                class="icon"
                icon="Warning"
              />
              Pendente
            </div>
            <div
              v-if="userGender"
              class="status solved"
            >
              <icon
                class="icon"
                icon="Check"
              />
              Resolvido
            </div>
            <div class="message">
              Seu cadastro precisa estar atualizado com as seguintes informações: <br>
              <b> nome, data de nascimento e sexo</b>.
            </div>
            <a
              :href="minhaConta"
              class="link"
            >
              Clique aqui para atualizar
            </a>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button
          @click="$emit('agreed')"
        >
          Entendi
        </button>
      </div>
    </div>
    <div class="overlay" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ModalInfo',
  computed: {
    ...mapGetters([
      'userGender',
    ]),
    minhaConta() {
      return `${process.env.VUE_APP_MINHACONTA_ROUTE}/profile/information`;
    }
  },
};
</script>

<style lang="scss" scoped>
  .modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 25px;
    background: $white;
    border-radius: 15px;
    z-index: 3;
    width: 90%;
    overflow: auto;
    max-height: 90vh;

    @include screen(tablet-big-up) {
      width: auto;
      top: 50%;
      min-width: 720px;
    }

    .close {
      position: absolute;
      top: 15px;
      right: 15px;

      &-icon {
        width: 15px;
        color: $step-select;
      }
    }

    figure {
      margin-bottom: 25px;

      img {
        margin-left: auto;
        margin-right: auto;
      }
    }

    .text {
      .title {
        font-size: $text-xl;
        margin-bottom: 5px;
        color: $gray-dark;
        text-align: center;

        b {
          margin-left: auto;
          margin-right: auto;
        }
      }

      .bottom-line {
        font-size: $text-base;
        text-align: center;
        color: $gray-txt;
      }
    }

    .check-list {
      display: flex;
      margin-top: 25px;

      @include screen(phone-only) {
        flex-direction: column;
      }

      &--item {
        padding: 0 10px;

        .status {
          display: flex;
          color: $white;
          width: fit-content;
          font-size: $text-xs;
          padding: 2px 10px;
          border-radius: 20px;
          margin-bottom: 10px;

          .icon {
            width: 15px;
            margin-right: 5px;
          }

          &.solved {
            background: $blue;
          }

          &.pending {
            background: $orange;
          }
        }

        .link {
          color: $blue;
          text-decoration: underline;
          font-weight: bold;
        }

        &:last-child {
          @include screen(phone-only) {
            margin-top: 25px;
          }
        }

        &.info {
          display: none;
        }

        &.unity {
          text-align: justify;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .buttons {
      margin-top: 45px;
      text-align: center;

      button {
        color: $white;
        background: $primary;
        width: 200px;
        padding: 15px;
        border-radius: 5px;
        font-weight: bold;
        font-size: $text-sm;
      }
    }
  }

  .overlay {
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #333;
      opacity: 0.7;
      z-index: 1;
    }
  }
</style>
